<template>
  <div class="form-con">
    <div class="title">找回密码</div>
    <input-group
      v-model="user.username"
      placeholder="请输入手机号"
      name="username"
      type="text"
      icon="icon-user"
    />

    <input-group
      v-model="user.sms_code"
      type="text"
      inputClass="code"
      icon="icon-sms"
      placeholder="输入验证码"
    >
      <div class="sms-code">
        <button @click="getMobileCode">获取验证码</button>
      </div>
    </input-group>

    <div class="form-group" id="np-verify-resetpwd"></div>

    <input-group
      v-model="user.password"
      v-if="initSmsCode"
      placeholder="请输入密码(8-20位字符)"
      name="password"
      type="password"
      icon="icon-pwd"
    />
    <input-group
      v-if="initSmsCode"
      v-model="user.repassword"
      placeholder="请再次输入密码"
      name="password"
      type="password"
      icon="icon-pwd"
    />

    <div class="form-group btn-group">
      <button @click="resetPwd">确定修改</button>
    </div>
  </div>
</template>

<script>
import InputGroup from "./InputGroup"
import checkFormMixin from '@/libs/checkFormMixin'
import {commonParams} from '@/libs/commonParamsStore.js'
export default {
  name: "ResetPwd",
  components: {InputGroup},
  props:['ncParams'],
  mixins: [checkFormMixin],
  data(){
    return {
      user:{
        username: '',
        password: '',
        repassword: '',
        sms_code:''
      },
      initSmsCode: false,
      commonParams
    }
  },
  methods:{
    async resetPwd(){
      let data = {...this.commonParams.state,...this.user}
      if(!this.checkUser(data) || !this.checkPassword(data.password)){
        return
      }
      const ret = await this.$apis.resetPassword(data,null,() => {
        this.$emit('resetNc')
        return 
      })
      if(!ret){return}
      this.$confirm(`<h3>${data.username}</h3>`,'密码修改成功，是否直接登录',{
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type:'success',
        center: true,
        dangerouslyUseHTMLString: true,
        closeOnClickModal: false
      }).then(() => {
        this.$emit('success',{'sso_token':ret.token,'sso_username':data.username,direct:true})
      }).catch((e) => {
        // 取消直接登录
        console.log(e)
      })
    },
    async getMobileCode(){
      if(!this.checkMobile(this.user.username)){
        return 
      }
      let data = this.checkNcParams()
      if(!data){
        this.$emit('resetNc')
        return
      }
      data['mobile'] = this.user.username
      data['type'] = 1
      data['dwd_appid'] = this.commonParams.state.dwd_appid
      let ret = await this.$apis.getSmsCode(data,null,()=>{
        this.$emit('resetNc')
        return false
      })
      if(!ret){return}
      this._success('短信发送成功')
      this.initSmsCode = true 
    }
  }
}
</script>

<style scoped>
.title {
  height: 40px;
  line-height: 40px;
  font-size: 18px;
  color: #3092fd;
  text-align: center;
  margin-top: -20px;
}
</style>